var _rect, _path, _path2, _path3, _ellipse, _ellipse2, _ellipse3, _ellipse4, _mask, _g, _path4, _rect2, _mask2, _g2, _path5, _rect3, _rect4, _path6, _path7, _path8, _rect5, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFormPublisherLogoPositive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 8.35156,
    width: 31.6117,
    height: 18.3789,
    rx: 9.18944,
    fill: "#6246E4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.524 1.80739C24.3996 2.00214 24.9953 2.79591 24.9953 3.69288V9.08671H6.61646V3.69289C6.61646 2.79591 7.21219 2.00214 8.08777 1.80739C10.4107 1.29072 13.0319 1 15.8059 1C18.5799 1 21.2011 1.29072 23.524 1.80739Z",
    fill: "#6246E4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0038 10.2679L27.5482 6.63867L27.9981 6.70954L27.4538 10.3388L27.0038 10.2679Z",
    fill: "#6246E4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8833 10.5596L29.6876 9.23828L29.9525 9.59916L28.1482 10.9205L27.8833 10.5596Z",
    fill: "#6246E4"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.11212,
    ry: 1.09321,
    transform: "matrix(0.98735 0.158232 -0.145806 0.989266 27.836 6.31018)",
    fill: "#6246E4"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.11212,
    ry: 1.09321,
    transform: "matrix(0.98735 0.158232 -0.145806 0.989266 30.4075 8.93518)",
    fill: "#6246E4"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.09917,
    cy: 23.8055,
    rx: 0.735155,
    ry: 0.735155,
    fill: "#4226C2"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.5209,
    cy: 23.8016,
    rx: 0.735155,
    ry: 0.735156,
    fill: "#4226C2"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 9,
    width: 30,
    height: 17
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.18935 9.82227C4.92619 9.82227 1.47021 13.2782 1.47021 17.5414C1.47021 21.8046 4.92618 25.2605 9.18934 25.2605H22.4221C26.6853 25.2605 30.1413 21.8046 30.1413 17.5414C30.1413 13.2782 26.6853 9.82227 22.4221 9.82227H9.18935ZM9.18932 11.2926C5.73819 11.2926 2.9405 14.0903 2.9405 17.5414C2.9405 20.9925 5.7382 23.7902 9.18933 23.7902H22.4221C25.8732 23.7902 28.6709 20.9925 28.6709 17.5414C28.6709 14.0903 25.8732 11.2926 22.4221 11.2926H9.18932Z",
    fill: "#4226C2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.47512 22.9838L25.1039 22.9414L26.3083 25.3172L5.37946 25.4013L6.47512 22.9838Z",
    fill: "#4226C2"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7897 29.7094C22.7897 30.1938 22.4428 30.61 21.9641 30.6838C20.0512 30.979 17.9752 31.1406 15.8058 31.1406C13.6363 31.1406 11.5603 30.979 9.64736 30.6838C9.16866 30.61 8.82178 30.1938 8.82178 29.7094V23.7891H22.7897V29.7094Z",
    fill: "url(#paint0_linear)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 8.82178,
    y: 23.7891,
    width: 13.9679,
    height: 0.749861,
    fill: "black"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 8,
    width: 32,
    height: 19
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.6117,
    height: 18.3789,
    rx: 9.18944,
    transform: "matrix(1 0 0 -1 0 26.7305)",
    fill: "#6246E4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.14606 8.35235C5.14606 9.97641 6.46262 11.293 8.08668 11.293H23.5249C25.149 11.293 26.4656 9.97641 26.4656 8.35235H5.14606Z",
    fill: "#4226C2"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.146 17.5414C5.146 15.3083 6.95627 13.498 9.18935 13.498H22.4221C24.6552 13.498 26.4655 15.3083 26.4655 17.5414C26.4655 19.7745 24.6552 21.5848 22.4221 21.5848H9.18935C6.95626 21.5848 5.146 19.7745 5.146 17.5414Z",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10.2921,
    y: 14.9688,
    width: 2.20546,
    height: 3.67578,
    rx: 1.10273,
    fill: "#6246E4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 19.114,
    y: 14.9688,
    width: 2.20547,
    height: 3.67578,
    rx: 1.10273,
    fill: "#6246E4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1158 3.78789C22.1158 3.31083 21.7793 2.89843 21.3089 2.8188C19.6068 2.53067 17.7626 2.37305 15.8364 2.37305C13.9102 2.37305 12.066 2.53067 10.3639 2.8188C9.89355 2.89843 9.55695 3.31083 9.55695 3.78789V9.7246H22.1158V3.78789Z",
    fill: "url(#paint1_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M22.1036 4.08017C20.1835 3.71471 18.059 3.51172 15.8242 3.51172C13.5894 3.51172 11.4648 3.71471 9.54474 4.08017V10.5447H22.1036V4.08017Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7897 5.87455C22.7897 5.39019 22.4428 4.97399 21.9641 4.90014C20.0512 4.60501 17.9752 4.44336 15.8058 4.44336C13.6363 4.44336 11.5603 4.60501 9.64736 4.90014C9.16866 4.97399 8.82178 5.39019 8.82178 5.87455V11.2926H22.7897V5.87455Z",
    fill: "url(#paint2_linear)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 8.82178,
    y: 10.5566,
    width: 13.9679,
    height: 0.749864,
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 15.8058,
    y1: 23.7891,
    x2: 15.8058,
    y2: 31.1406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCBC14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 15.8364,
    y1: 2.37305,
    x2: 15.8364,
    y2: 10.2638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCBC14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 15.8058,
    y1: 4.44336,
    x2: 15.8058,
    y2: 11.7949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCBC14"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormPublisherLogoPositive);
export default __webpack_public_path__ + "static/media/form-publisher-logo-positive.93ee66d7.svg";
export { ForwardRef as ReactComponent };